export default __webpack_public_path__ + "static/media/next.e1ad7287.svg";